import { createAction } from 'redux-actions';

export const validationSettingsRequest = createAction(
  'validation/validation-settings-request',
);

export const validationSettingsResponse = createAction(
  'validation/validation-settings-response',
);
